import { Stack, Text } from "@mantine/core";
import { SamblaLogoLottie } from "./SamblaLogoLottie";

interface LoaderViewProps {
  /** Optional message shown beneath the animation. */
  message?: string;
  size?: number;
}

export function LoaderView({ message, size = 160 }: LoaderViewProps) {
  return (
    <Stack
      role="status"
      align="center"
      justify="center"
      gap="xl"
      py="xl"
      px="lg"
    >
      <SamblaLogoLottie size={size} />
      {message && (
        <Text
          fz="h3"
          fw={700}
          lh="h3"
          ff="var(--wallet-font-family-sambla-sans)"
          ta="center"
        >
          {message}
        </Text>
      )}
    </Stack>
  );
}
